import styled, {useTheme} from "styled-components";
import {StyledProps, Theme} from "../../theme";
import {ReactComponent as NextSvg} from "../../assets/next.svg";
import {FaCheck} from 'react-icons/fa'
import {zfill} from "../../utils";
import {CvvStrings} from "../../strings";

const Circle = styled.div`
  position: absolute;
  right: -20px;
  width: 40px;
  height: 40px;
  display: flex;
  border-radius: 100%;
  background-color: ${({theme}: StyledProps) => theme.primary};
  justify-content: center;
  align-items: center;
`;

const Container = styled.div<{ selected: boolean }>`
  display: flex;
  position: relative;
  border: solid 1px ${({theme}: StyledProps) => theme.content};
  border-left: solid ${({selected}) => selected ? '10px' : '1px'} ${({theme}: StyledProps) => theme.content};
  min-height: 56px;
  padding: 0 15px 0;
  margin-right: calc(35px / 2);
  transition: background-color 200ms ease, border-left-width 200ms ease;
  cursor: pointer;
  align-items: center;
  user-select: none;

  &:hover {
    background-color: ${({theme}: StyledProps) => theme.content10};
  }
`;

const PickContainer = styled.div`
  border-left: solid 1px ${({theme}: StyledProps) => theme.content};
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-top: 16px;
  margin-bottom: 16px;
  align-self: stretch;
  padding: 0 16px 0 16px;
  ${({theme}: StyledProps) => theme.textTheme.body.css};
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

interface CvvLessonSlotProps {
    title: any
    subtitle?: any
    selected: boolean
    freePlaces?: number | null
}

export const CvvLessonSlot = (props: CvvLessonSlotProps) => {
    const theme = useTheme() as Theme;
    return <Container selected={props.selected}>
        <ContentContainer>
            <theme.textTheme.headline5.span>
                {props.title}
                {props.freePlaces && <theme.textTheme.body.span style={{display: 'block'}}>
                    Prosta mesta: {props.freePlaces}
                </theme.textTheme.body.span>}
            </theme.textTheme.headline5.span>
            <theme.textTheme.body.span>
                {props.subtitle}
            </theme.textTheme.body.span>
        </ContentContainer>
        <PickContainer>
            {props.selected ? 'IZBRANO' : 'IZBERITE'}
        </PickContainer>
        <Circle>
            {props.selected ? <FaCheck/> : <NextSvg style={{color: theme.content, width: '15px'}}/>}
        </Circle>
    </Container>;
}

interface CvvMultidayLessonSlotProps {
    dates: Date[]
    price: string
    selected: boolean
    freePlaces?: number | null
}

export const CvvMultidayLessonSlot = (props: CvvMultidayLessonSlotProps) => {
    const theme = useTheme() as Theme;
    return <Container selected={props.selected}>
        <ContentContainer style={{padding: '4px 0'}}>
            <theme.textTheme.headline5.span style={{textDecoration: 'underline', marginBottom: '4px'}}>
                {props.freePlaces} {CvvStrings.prostihMest(props.freePlaces)} ({props.price})
            </theme.textTheme.headline5.span>
            {props.dates.map((date, index) => {
                return (
                    <theme.textTheme.headline6.span key={`${date.getTime()}-${index}`}>
                        <b>{index + 1}. dan:</b> {date.getDate()}. {date.getMonth() + 1}. {date.getFullYear()} ob {date.getHours()}.{zfill(date.getMinutes(), 2)}
                    </theme.textTheme.headline6.span>
                );
            })}
        </ContentContainer>
        <PickContainer>
            {props.selected ? 'IZBRANO' : 'IZBERITE'}
        </PickContainer>
        <Circle>
            {props.selected ? <FaCheck/> : <NextSvg style={{color: theme.content, width: '15px'}}/>}
        </Circle>
    </Container>;
}
